import {Component} from "preact";
import CdnResourceResolverService from "../../../../../../services/CdnResourceResolverService";
import styles from "./styles.scss";

export default class LanguageFlagIcon extends Component {
    constructor(props) {
        super(props);

        this.state = {
            imageError: false
        };
    }


    static defaultProps = {
        language: ''
    };

    render(props, state, context) {
        return (this.state.imageError) ?
            null :
            <img
                class={styles.flag}
                src={CdnResourceResolverService.getResource('bandiere', {country: props.language, extension: 'svg'})}
                onError={this.onImageError}
            />
        ;
    }

    onImageError = () => {
        this.setState({imageError: true});
    }
}


// WEBPACK FOOTER //
// ./components/sections/personal-area/sections/user/language-flag-icon/index.js